import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9c7b8dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table table-hover",
  id: "logTable"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }, "Time"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }, "Description"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }, "Triggering user"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }, "Users affected"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "col"
    }, "Groups affected")
  ])
], -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "glyphicon glyphicon-plus text-muted"
}
const _hoisted_5 = {
  key: 1,
  class: "glyphicon glyphicon-minus text-muted"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "hidden-on-collapse" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "event-property-key" }, "Type:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "event-property-key" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["href"]
const _hoisted_17 = { key: 0 }

import { ref, triggerRef } from "vue";
import moment from "dayjs";
import { EventLogEntryApiModel } from "../../api-models";
import resolveReportLink from "./report-link-resolver";


export default /*#__PURE__*/_defineComponent({
  __name: 'event-log-table',
  props: {
    events: {}
  },
  setup(__props: any) {

const props = __props;

const expandedEvents = ref<Record<string, boolean>>({});

function getReportLink(event: EventLogEntryApiModel): string {
  const reportUrl = resolveReportLink(event.type);
  const reportId = event.extraProperties.find((p) => p.key === "ReportId")?.value ?? "";
  return reportUrl + reportId;
}

function isEventExpanded(index: number): boolean {
  return expandedEvents.value[index];
}

function getFormattedDate(timestamp: string): string {
  return moment.utc(timestamp).local().format("D/M/YYYY H:mm:ss");
}

function toggleEventExpansion(index: number): void {
  if (typeof expandedEvents.value[index] === "undefined") {
    expandedEvents.value[index] = false;
  }
  expandedEvents.value[index] = !expandedEvents.value[index];
  triggerRef(expandedEvents);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: event.timestamp,
          class: _normalizeClass(["event-table-row", {
          expanded: isEventExpanded(index),
        }])
        }, [
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              type: "button",
              class: "showHideButton btn btn-default btn-xs",
              style: {"margin":"-1px 0"},
              "aria-label": "open more details",
              onClick: ($event: any) => (toggleEventExpansion(index))
            }, [
              (!isEventExpanded(index))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5))
            ], 8, _hoisted_3)
          ]),
          _createElementVNode("td", null, _toDisplayString(getFormattedDate(event.timestamp)), 1),
          _createElementVNode("td", null, [
            (event.extraProperties.find((p) => p.key === 'ReportId'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  href: getReportLink(event)
                }, _toDisplayString(event.displayName), 9, _hoisted_6))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(event.displayName), 1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(event.type), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.extraProperties, (prop) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: prop.key
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(prop.key) + ":", 1),
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(prop.value !== null ? prop.value.toString() : "null"), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("a", {
              href: `/admin/user/details/${
              event.triggeredByUser ? event.triggeredByUser.userId : ''
            }`,
              target: "_blank",
              rel: "noopener noreferrer"
            }, _toDisplayString(event.triggeredByUser ? event.triggeredByUser.userEmail : ""), 9, _hoisted_13)
          ]),
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.usersAffected, (user, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: user.userId
              }, [
                _createElementVNode("a", {
                  href: `/admin/user/details/${user.userId}`,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(user.userEmail), 9, _hoisted_14),
                (index + 1 < event.usersAffected.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.groupsAffected, (group, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: group.groupId
              }, [
                _createElementVNode("a", {
                  href: `/admin/group/details/${group.groupId}`,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(group.groupName), 9, _hoisted_16),
                (index + 1 < event.groupsAffected.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})